import { usePlanCreatorContext } from "@components/PlanCreator/PlanCreatorContext";
import { useCallback, useEffect, useState } from "react";
import { dev } from "@utils/dev";
import { isEmptyPeriods } from "@components/PlanCreator/Periods.utils";

export default function useWeekPlanExcluderControl() {

  const {
    disabled,
    periods,
    weekDayPeriods,
    setPeriods,
  } = usePlanCreatorContext();

  const [isWeekPlanUsed, setWeekPlanUsed] = useState(false);
  const [isShowWeekPlan, setShowWeekPlan] = useState(false);

  useEffect(() => {
    if (periods.length === 0 && weekDayPeriods !== undefined) {
      setShowWeekPlan(true);
    } else if (isEmptyPeriods(periods)) {
      setShowWeekPlan(true);
    } else {
      setShowWeekPlan(false);
    }
    setWeekPlanUsed(!isEmptyPeriods(periods));

  }, [periods, weekDayPeriods]);

  const useWeekPlanChanged = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    if (isEmptyPeriods(periods)) {
      setPeriods([]);
    } else {
      setPeriods([{
        id: 0,
        time: ["00:00", "00:00"],
        active: true,
        priority: 0,
      }]);
    }
  }, [periods]);

  return {
    disabled,
    weekDayPeriods,
    isWeekPlanUsed,
    isShowWeekPlan,
    useWeekPlanChanged,
  }
}